import { Card } from 'canoe';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React, { useEffect } from 'react';

import { ContentType } from '@candu-ai/content/types';
import { BuiltInComponents } from 'craft/constants';

import { SelectContentTypeForm } from './components/SelectContentTypeForm';
import { Stepper } from './components/Stepper';
import { WizardView } from './components/WizardView';

interface SelectContentTypeProps {
  templateDocument: any;
  onSelect?: (contentType: string) => void;
}

export const SelectContentTypeWithTemplateImpl = ({
  onSelect,
  templateDocument,
}: SelectContentTypeProps) => {
  const rootNode = templateDocument.document.nodes[templateDocument.document.rootNodeId];

  useEffect(() => {
    if (rootNode.type === BuiltInComponents.Modal) {
      onSelect?.(ContentType.Modal);
    }
    if (rootNode.type === BuiltInComponents.HotspotGroup) {
      onSelect?.(ContentType.HotspotGroup);
    }
    if (rootNode.type === BuiltInComponents.Tour) {
      onSelect?.(ContentType.Tour);
    }
    if (rootNode.type === ContentType.Banner) {
      onSelect?.(ContentType.Banner);
    }
    if (rootNode.type === BuiltInComponents.Document) {
      onSelect?.(ContentType.Inline);
    }
  }, [rootNode, onSelect]);

  const onSubmit = (payload: { contentType: string }) => {
    onSelect?.(payload.contentType);
  };

  return (
    <Card size="xl">
      <Stepper currentStep={1} />
      <WizardView title="Create Content" subTitle="Let's start by choosing your Content Type">
        <SelectContentTypeForm onSubmit={onSubmit} contentType={rootNode.type} withTemplate />
      </WizardView>
    </Card>
  );
};

export const SelectContentTypeWithTemplate = connectWithHammock(
  ({ templateId, notFoundComponent }) => ({
    id: templateId,
    endpoint: ENDPOINTS.templateDocumentsEditor,
    notFoundComponent,
    resourceName: 'templateDocument',
  }),
)(SelectContentTypeWithTemplateImpl);
